import { Alert } from 'react-native';

export class Toast {
  static show(message: string, type: 'success' | 'error' | 'info' = 'info') {
    const title =
      type === 'success' ? 'Success' : type === 'error' ? 'Error' : 'Info';
    Alert.alert(title, message);
  }
}
